import taoteHandler from "@/views/moving_function/views/select_goods/platform/taote/handler";
import aliHandler from "@/views/moving_function/views/select_goods/platform/1688/handler";
import indexHandler from "@/views/moving_function/handler";
import { message } from "ant-design-vue";
import { GetAllMovedGoodsId } from "@/views/moving_function/views/select_goods/api";
import imgUtil from "@/views/moving_function/utils/img";

// 获取对应平台的handler
function GetCurrentPlatformHandler(type) {
  let handler = taoteHandler;
  if (type?.includes("ali")) handler = aliHandler;
  return handler;
}

// 商品列表上加上是否已铺货的标记
async function setIsMoved(list, obj) {
  let isMovedIdMap = sessionStorage.getItem("pdd_xiaofeng_shanghuo_is_moved_success_ids");
  isMovedIdMap = isMovedIdMap ? JSON.parse(isMovedIdMap) : await GetAllMovedGoodsId();
  if (isMovedIdMap && Object.keys(isMovedIdMap).length) {
    list.map((item) => {
      item.isMoved = isMovedIdMap[item.id] && !obj?.canCommitRepeat ? true : false;
    });
  }
}

// 格式化搜图接口返回的数据
async function formatGoodsList(list, type) {
  const arr = [];
  for (let item of list) {
    const id = item.ItemId || item.id;
    const img = item.Pic || item.itemSquarePic;
    let link = `https://market.m.taobao.com/app/ltao-fe/ltao-lite/productdetail.html?id=${id}`;
    if (type.includes("ali")) link = `https://detail.1688.com/offer/${id}.html`;
    const price = item.Price || item.itemPrice;
    const obj = {
      id,
      name: item.Title || item.itemTitle,
      img,
      link,
      price: price ? +price : 0,
      sold: item.Sold || item.itemSales,
      serviceList: item.ServiceList || [],
    };
    arr.push(obj);
  }
  return arr;
}

// 搜图
async function GetGoodsListBySearchImg(This, filter) {
  const { currentItem, currentPlatformType } = This;
  var SearchGoodsByImage = GetCurrentPlatformHandler(currentPlatformType).SearchGoodsByImage;
  let { keyword } = currentItem.params;
  if (keyword.includes("-item.ecombdimg.com"))
    keyword = keyword.replace(/p\d+-item.ecombdimg.com/, "p6-item.ecombdimg.com");
  let obj = { imageUrl: keyword };
  if (keyword?.includes("blob:")) {
    keyword = await imgUtil.GetFinalBase64(keyword);
    obj = { imageData: keyword };
  }
  if (filter && currentPlatformType === "ali") obj.filter = filter;
  const { list, msg, success, info, total } = await SearchGoodsByImage(obj);
  const currentPlatform = currentItem.platformInfo[`${currentPlatformType}_info`];
  if (!success) {
    if (!info) return message.warning(msg);
    // 淘特
    if (currentPlatformType === "taote") indexHandler.ShowTaoteAuthModal(This, info);
    // 1688
    else if (currentPlatformType === "ali") {
      await indexHandler.ShowAliAuthModal(info);
      return GetGoodsListBySearchImg(This, currentItem, currentPlatformType);
    }
    currentPlatform.list = [];
    return (currentPlatform.total = 0);
  }
  if (!list.length) {
    currentPlatform.list = [];
    currentPlatform.total = 0;
    return message.warning("没有搜索到商品数据，请重试");
  }
  currentPlatform.list = await formatGoodsList(list, currentPlatformType);
  currentPlatform.total = total;
  currentPlatform?.list.sort((res1, res2) => {
    return res1.price - res2.price;
  });
  This.$message.success("加载成功");
  setIsMoved(currentPlatform.list, { canCommitRepeat: This.$refs.currentGoodsTemplate?.is_repeat });
}

export default { GetGoodsListBySearchImg };
